import { CONSOLE_TABS, type ConsoleTab } from '@badger-sentinel/rules';

/**
 * Tab display names (M5-D10).
 *
 * A constant table, not a scenario's business: `MW` is the wire's name for the
 * module and `MISSILE WARNING` is what a console calls it. `CONSOLE_TABS` is
 * the canonical order and the projection already emits the seat's set in it, so
 * the strip is right on first paint without the client sorting anything.
 */
export const TAB_LABELS: Readonly<Record<ConsoleTab, string>> = Object.freeze({
  THEATRE: 'REGION MAP',
  // Not 'SPACE · SDA'. The middot is this console's separator — `LINK · 54 MS`,
  // `UNDONE · label` — so a label containing one parses as two tabs, and SDA
  // already means space domain awareness.
  SDA: 'SPACE SDA',
  CYBER: 'CYBER',
  MW: 'MISSILE WARNING',
  INTEL: 'INTEL',
});

export function tabLabel(tab: ConsoleTab): string {
  return TAB_LABELS[tab];
}

/**
 * The tab to show, given the seat's set and whatever was selected before it.
 *
 * A seat whose tab set changes — it cannot today, but Phase 9's per-scenario
 * table makes it a live possibility — must not be left pointing at a tab it no
 * longer has. Falls back to the first tab in canonical order.
 */
export function resolveTab(
  tabs: readonly ConsoleTab[],
  selected: ConsoleTab | null,
): ConsoleTab | null {
  if (selected !== null && tabs.includes(selected)) return selected;
  return CONSOLE_TABS.find((tab) => tabs.includes(tab)) ?? null;
}
